import { useCallback } from 'react'
import { ReactFCC } from '@/types/react'
import { useTranslate } from '@/utils/translate/translate-client'
import { OptionGroup } from '../../components/OptionGroup'

interface TorchProductionProps {
  disabled?: boolean
  name: string
  value?: string
  onChange: ({ name, value }: { name: string; value: string }) => void
}

export const TorchProduction: ReactFCC<TorchProductionProps> = ({ disabled, name, value, onChange }) => {
  const { t } = useTranslate('guild-create')

  const options = [
    {
      label: t('preproduction', 'Pre-Production'),
      value: 'PreProduction',
    },
    { label: t('productionInProgress', 'In Progress'), value: 'InProgress' },
    { label: t('productionPostProduction', 'Post Production'), value: 'PostProduction' },
    { label: t('completed', 'Completed'), value: 'Completed' },
  ]

  const handleChange = useCallback(
    (value: string[]) => {
      onChange({ name, value: value[0] ?? '' })
    },
    [name, onChange],
  )

  return (
    <OptionGroup
      label={t('productionStage', 'Production Stage')}
      options={options}
      name={name}
      value={value ? [value] : []}
      onChange={handleChange}
      required
      disabled={disabled}
      limit={1}
    />
  )
}
